import { createRoutine } from 'redux-saga-routines';
//////////////////////////////////////////////////

const REPORT = 'REPORT';
const EDIT_REPORT = 'EDIT_REPORT';
const CREATE_REPORT = 'CREATE_REPORT';
const REMOVE_REPORT = 'REMOVE_REPORT';
const FETCH_REPORTS_LIST_DATA = 'FETCH_REPORTS_LIST_DATA';

const changeUsedReportRoutine = createRoutine(REPORT);
const editUsedReportRoutine = createRoutine(EDIT_REPORT);
const addUsedReportRoutine = createRoutine(CREATE_REPORT);
const deleteUsedReportRoutine = createRoutine(REMOVE_REPORT);
const fetchReportsListData = createRoutine(FETCH_REPORTS_LIST_DATA);

export {
  addUsedReportRoutine,
  fetchReportsListData,
  editUsedReportRoutine,
  deleteUsedReportRoutine,
  changeUsedReportRoutine,
};
